import {
  COMMUNICATION_METHOD_BOTH_TEXT_AND_EMAIL,
  COMMUNICATION_METHOD_EMAIL,
  COMMUNICATION_METHOD_FAX,
  COMMUNICATION_METHOD_TEXT_SMS,
  COMMUNICATION_METHOD_TYPES_GENERATED_BY,
  PHONE_TYPE_MOBILE,
} from "constants/patients";
import type { Patient } from "services/types/patients.type";

export const getCommunicationMethodOptions = (
  selectedPatient: Patient | null,
): {
  label: string;
  value: string;
  disabled?: boolean;
  template?: string;
}[] => {
  return COMMUNICATION_METHOD_TYPES_GENERATED_BY.getOptions([
    COMMUNICATION_METHOD_FAX,
    COMMUNICATION_METHOD_BOTH_TEXT_AND_EMAIL,
  ]).map((option) => {
    if (!selectedPatient) {
      return { ...option, disabled: true };
    }

    if (Number(option.value) === COMMUNICATION_METHOD_TEXT_SMS) {
      const disabled = Boolean(
        !selectedPatient?.phone ||
          Number(selectedPatient?.phone_type) !== PHONE_TYPE_MOBILE,
      );

      return {
        ...option,
        disabled,
        tooltip: disabled ? "Patient has no mobile number" : "",
      };
    }

    if (Number(option.value) === COMMUNICATION_METHOD_EMAIL) {
      const disabled = !selectedPatient?.email;

      return {
        ...option,
        disabled,
        tooltip: disabled ? "Patient has no email address" : "",
      };
    }

    return { ...option };
  });
};
